import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useData } from "../context/Context";
import MainModels from "./MainModels";
import TableModel from "./TableModel";

const Index = () => {
  const { taskId } = useParams();
  const {
    state: { selected_table, selected_task_id },
    setState,
  } = useData();

  // Handle task-based routing
  useEffect(() => {
    if (taskId) {
      // Clear table selection and set task_id when on a task route
      setState((prev) => ({
        ...prev,
        selected_table: "",
        selected_task_id: taskId,
      }));
    }
  }, [taskId, setState]);

  // Show MainModels if either a table is selected OR we're on a task route
  const shouldShowMainModels = selected_table || taskId || selected_task_id;

  return <>{shouldShowMainModels ? <MainModels /> : <TableModel />}</>;
};

export default Index;
